import { useTranslation } from "react-i18next";
import { Button } from "../core/basic/Button";

const DownloadPDFv2 = ({ url }) => {
  const { t } = useTranslation(["common"]);
  return (
    <Button
      variant={"primary"}
      onPress={() => {
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.target = "_blank";
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      }}
    >
      {t(($) => $.common["Download PDF"])}
    </Button>
  );
};

export default DownloadPDFv2;
